'use client';

import { GoatAwkward } from '@capsicum/common';
import { GenericDrawer } from '@capsicum/common-web';
import { useExportAndCloseAccountErrorDrawer } from '@capsicum/features/account/shared';

export type ExportAndCloseAccountErrorDrawerProps = {
	closeModal: () => void;
};

export const ExportAndCloseAccountErrorDrawer = ({ closeModal }: ExportAndCloseAccountErrorDrawerProps) => {
	const { intlTexts } = useExportAndCloseAccountErrorDrawer();

	const drawerData = {
		closeButtonText: intlTexts.closeButton,
		description: intlTexts.errorDescription,
		image: GoatAwkward,
		isButtonFullWidth: true,
		isButtonOnRow: false,
		testID: 'settings-accountManagement-exportAndCloseAccount-errorDrawer',
		title: intlTexts.errorTitle
	};

	return <GenericDrawer {...drawerData} onButtonPress={closeModal} />;
};
